// extracted by mini-css-extract-plugin
module.exports = {"InfoIcon__btn":"InfoIcon__btn__38DTK","InfoIcon__btn__default":"InfoIcon__btn__default__19M0l","InfoIcon__btn__indigo":"InfoIcon__btn__indigo__2mGsG"};